import React from 'react';
import { useAsync } from 'react-use';

import {
  useApi,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { JiraAPIClient } from '../api';

export const useFetchProjects = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef);

  const client = React.useMemo(
    () =>
      new JiraAPIClient({
        discoveryApi,
        fetchApi,
        identityApi,
      }),
    [discoveryApi, fetchApi, identityApi],
  );

  const { value, loading, error } = useAsync(
    () => client.fetchProjects(),
    [client],
  );

  return {
    projects: value ?? [],
    loading,
    error,
  };
};
